import { render, staticRenderFns } from "./InArticleAdsense.vue?vue&type=template&id=180cd560&"
import script from "./InArticleAdsense.vue?vue&type=script&lang=js&"
export * from "./InArticleAdsense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports